import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__main" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "footer__newsletter"
}
const _hoisted_5 = { class: "footer__social-links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "footer__links" }
const _hoisted_8 = { class: "footer__bottom-wrapper" }
const _hoisted_9 = { class: "footer__bottom" }
const _hoisted_10 = { class: "footer__country-select" }
const _hoisted_11 = {
  key: 0,
  class: "footer__payment-methods"
}
const _hoisted_12 = ["src"]

import { inject, computed } from 'vue';

import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';
import FooterLinks from './FooterLinks.vue';
import CountrySwitcher from '../CountrySwitcher.vue';
import { channelKey } from '@/keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteFooter',
  setup(__props) {

const channel = inject(channelKey);
const toLitiumMediaUrl = inject(toLitiumMediaUrlKey);
const newsletter = computed(() => channel?.value?.footerNewsletterSignup?.Newsletter?.slice(0, 1));

const logoUrl = computed(() => {
  const logo = channel?.value?.frameworkContentJson?.CompanyLogo;
  return toLitiumMediaUrl?.(logo?.id, { maxHeight: 27 }) || '';
});

const logoAlt = computed(() => {
  const logo = channel?.value?.frameworkContentJson?.CompanyLogo;
  return logo?.alt;
});

const paymentMethods = computed(() => {
  const imageIds = channel?.value?.frameworkContentJson?.PaymentMethodImages;
  return imageIds?.map((i) => toLitiumMediaUrl?.(i.entitySystemId, { maxHeight: 20 })) || [];
});

const socialLinks = computed(() => channel?.value?.frameworkContentJson?.SocialLinks);


return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "footer__logo",
        src: _unref(logoUrl),
        alt: _unref(logoAlt)
      }, null, 8, _hoisted_3),
      (_unref(newsletter))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_blocks_repeater, { blocks: _unref(newsletter) }, null, 8, ["blocks"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialLinks), (social) => {
          return (_openBlock(), _createElementBlock("a", {
            class: "footer__social-link",
            key: social.Label,
            target: "_blank",
            href: social.SocialLink
          }, _toDisplayString(social.Label), 9, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FooterLinks)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CountrySwitcher)
        ]),
        (_unref(paymentMethods)?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentMethods), (paymentMethod, idx) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: idx,
                  src: paymentMethod,
                  class: "footer__payment-method"
                }, null, 8, _hoisted_12))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})